(function(window, answersViewFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.AnswersView = answersViewFactory(
      window,
      window.$,
      namespace.templates,
      namespace.deviceInfo,
      namespace.textSanitizer,
      namespace.questionType,
      namespace.log,
      namespace.viewHelper,
      namespace.localizationStrings);
})(this, function(window, $, templates, deviceInfo, textSanitizer, questionType, log, viewHelper, localizationStrings) {
   'use strict';

   var CHECK_SVG = '<svg id="Correct" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42"><style>.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#97C93D;} .st1{fill:#82AD40;} .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}</style><path class="st0" d="M21 39c-9.9 0-18-8.1-18-18S11.1 3 21 3s18 8.1 18 18-8.1 18-18 18z"/><path class="st1" d="M21 5c8.8 0 16 7.2 16 16s-7.2 16-16 16S5 29.8 5 21 12.2 5 21 5m0-4C10 1 1 10 1 21s9 20 20 20 20-9 20-20S32 1 21 1z"/><path class="st2" d="M30 16.6l-11.2 12c-.8.8-1.8.3-2.3-.2l-4.8-5.9c-.5-.7-.4-1.6.3-2.2.7-.5 1.6-.4 2.1.3l3.7 4.5 10-10.8c.6-.6 1.5-.6 2.1 0 .7.7.7 1.7.1 2.3z"/></svg>';
   var INCORRECT_SVG = '<svg id="Wrong" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42"><style>.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#EF4546;} .st1{fill:#B93130;} .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}</style><path class="st0" d="M21 39c-9.9 0-18-8.1-18-18S11.1 3 21 3s18 8.1 18 18-8.1 18-18 18z"/><path class="st1" d="M21 5c8.8 0 16 7.2 16 16s-7.2 16-16 16S5 29.8 5 21 12.2 5 21 5m0-4C10 1 1 10 1 21s9 20 20 20 20-9 20-20S32 1 21 1z"/><path class="st2" d="M24.2 21l4.1 4.1c.9.9.9 2.4 0 3.3-.9.9-2.4.9-3.3 0l-4-4.2-4 4c-.9.9-2.3.9-3.2 0s-.9-2.3 0-3.2l4-4-4.1-4.1c-.9-.9-.9-2.4 0-3.3.9-.9 2.4-.9 3.3 0l4.1 4.1 4-4c.9-.9 2.3-.9 3.2 0 .9.9.9 2.3 0 3.2L24.2 21z"/></svg>';
   var CORRECT_GLYPH_DATA_URL = 'data:image/svg+xml,' + window.encodeURIComponent(CHECK_SVG);
   var INCORRECT_GLYPH_DATA_URL = 'data:image/svg+xml,' + window.encodeURIComponent(INCORRECT_SVG);
   var PLACEHOLDER_GLYPH_DATA_URL = 'data:image/png;base64,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';
   var ACTIVE_QUESTION_CLASS = 'active-question-item';
   var CORRECT_ANSWER_TEXT = localizationStrings.strings.txtCorrectAnswer;
   var YOUR_ANSWER_TEXT = localizationStrings.strings.txtYourAnswer;

   /**
    * @memberof TSC
    * @class AnswersView
    * @classdesc Answers View
    */
   var AnswersView = function($container, question, showResults) {
      var _$window = $(window);
      var _choiceAnswerTemplate = null;
      var _fillAnswerTemplate = null;
      var _shortAnswerTemplate = null;
      var _$textInput = null;

      if (templates && templates.choice_answer_template) {
         _choiceAnswerTemplate = templates.choice_answer_template;
      } else {
         log.logException('Answers View: Multiple Choice Answer Template not found.');
      }

      if (templates && templates.fill_answer_template) {
         _fillAnswerTemplate = templates.fill_answer_template;
      } else {
         log.logException('Answers View: Fill In The Blank Answer Template not found.');
      }

      if (templates && templates.short_answer_template) {
         _shortAnswerTemplate = templates.short_answer_template;
      } else {
         log.logException('Answers View: Short Answer Template not found.');
      }

      var getUserResponse = function() {
         switch (question.type) {
            case questionType.CHOICE:
               return $container.find('input[name=multiple-choice]:checked').val();
            case questionType.FILL_IN:
               return $container.find('input').val();
            case questionType.SHORT:
               return $container.find('textarea').val().replace(/^[ \t]+|[ \t]+$/, '');
         }
      };

      var displayResponseFillInResults = function() {
         if (!question.isGraded) {
            return;
         }
         var $correctImage = $("<img src='" + CORRECT_GLYPH_DATA_URL + "' class='image-fill-in-the-blank-feedback' alt='" + localizationStrings.strings.txtCorrectString + "' />");
         var $incorrectImage = $("<img src='" + INCORRECT_GLYPH_DATA_URL + "' class='image-fill-in-the-blank-feedback' alt='" + localizationStrings.strings.txtIncorrectString + "' />");

         if (question.isResponseCorrect) {
            $container.find('img.feedback-placeholder').replaceWith($correctImage);
         } else {
            $container.find('img.feedback-placeholder').replaceWith($incorrectImage);
         }
      };

      var getCorrectAnswerIndex = function() {
         var numberAnswers = question.answers.length;
         var correctAnswerBitshifted = question.correctAnswer;
         for (var i = 0; i < numberAnswers; i++) {
            /*eslint no-bitwise: "off"*/
            if (1 << i === Number(correctAnswerBitshifted)) {
               return i;
            }
         }

         return -1;
      };

      var displayChoiceResults = function() {
         var correctAnswerIndex;
         var $placeHolderImgEls;
         var $userResponseInputImageEl;
         var $correctResponseInputImageEl;
         var $correctImage;
         var $incorrectImage;
         var answerIndex = question.userResponse;
         var $labelEls = $container.find('label');

         $labelEls.removeClass(ACTIVE_QUESTION_CLASS);

         if (showResults && question.isGraded) {
            correctAnswerIndex = getCorrectAnswerIndex();
            $placeHolderImgEls = $container.find('label img');
            $userResponseInputImageEl = $container.find('label:eq(' + answerIndex + ') img');
            $correctResponseInputImageEl = $container.find('label:eq(' + correctAnswerIndex + ') img');
            $correctImage = $("<img src='" + CORRECT_GLYPH_DATA_URL + "' class='image-feedback' alt='" + localizationStrings.strings.txtCorrectString + "' />");
            $incorrectImage = $("<img src='" + INCORRECT_GLYPH_DATA_URL + "' class='image-feedback' alt='" + localizationStrings.strings.txtIncorrectString + "' />");

            $placeHolderImgEls.removeClass('feedback-placeholder');

            if (answerIndex === correctAnswerIndex) {
               $userResponseInputImageEl.replaceWith($correctImage);
               $correctImage.css('opacity', 0);
               $correctImage.animate({opacity: 1}, 200);
            } else {
               $correctResponseInputImageEl.replaceWith($correctImage);
               $correctImage.css('opacity', 0);
               $correctImage.animate({opacity: 1}, 200);

               $userResponseInputImageEl.replaceWith($incorrectImage);
               $incorrectImage.css('opacity', 0);
               $incorrectImage.animate({opacity: 1}, 200);
            }
         }

         $container.find('input').hide();

         if (answerIndex !== undefined) {
            $container.find('label:eq(' + answerIndex + ')').addClass('picked-quiz-item');
         }
      };

      var disableInput = function() {
         var $inputEls = null;
         switch (question.type) {
            case questionType.CHOICE:
            case questionType.FILL_IN:
               $inputEls = $container.find('input');
               break;
            case questionType.SHORT:
               $inputEls = $container.find('textarea');
               break;
         }
         if ($inputEls) {
            $inputEls.attr('disabled', true);
         }
      };

      var displayResults = function() {
         switch (question.type) {
            case questionType.CHOICE:
               displayChoiceResults();
               break;
            case questionType.FILL_IN:
               displayResponseFillInResults();
               break;
         }
         disableInput();
      };

      var getChoiceAnswersMarkupContext = function(answers, userResponse) {
         var templateContext = {};
         templateContext.questionText = question.text;
         templateContext.answers = [];
         templateContext.placeHolderImg = PLACEHOLDER_GLYPH_DATA_URL;

         answers.forEach(function(answer, index) {
            if (userResponse && index === parseInt(userResponse, 10)) {
               templateContext.answers.push({
                  answerIndex: index,
                  answer: answer.text,
                  isChecked: true
               });
            } else {
               templateContext.answers.push({
                  answerIndex: index,
                  answer: answer.text
               });
            }
         });
         return templateContext;
      };

      var getFillInTheBlankAnswerMarkupContext = function(userResponse, autoFocus) {
         var templateContext = {};
         templateContext.questionText = question.text;
         templateContext.inputLabel = 'Fill in question answer';
         templateContext.inputId = 'fill-in-the-blank-input';
         templateContext.inputName = 'fill-in-the-blank-input';
         templateContext.placeHolderImg = PLACEHOLDER_GLYPH_DATA_URL;
         templateContext.userResponse = userResponse;
         if (autoFocus) {
            templateContext.useAutofocus = 'true';
         }
         return templateContext;
      };

      var getShortAnswerMarkupContext = function(userResponse, autoFocus) {
         var templateContext = {};
         templateContext.questionText = question.text;
         templateContext.inputLabel = 'Supply your response';
         templateContext.inputId = 'short-answer-input';
         templateContext.inputName = 'short-answer-input';
         templateContext.userResponse = userResponse;
         if (autoFocus) {
            templateContext.useAutofocus = 'true';
         }
         return templateContext;
      };

      var getAnswersMarkup = function(autoFocus) {
         if (deviceInfo.isIOS() || deviceInfo.isAndroid()) {
            autoFocus = false;
         }

         switch (question.type) {
            case questionType.CHOICE:
               return _choiceAnswerTemplate(getChoiceAnswersMarkupContext(question.answers, question.userResponse));
            case questionType.FILL_IN:
               return _fillAnswerTemplate(getFillInTheBlankAnswerMarkupContext(question.userResponse, autoFocus));
            case questionType.SHORT:
               return _shortAnswerTemplate(getShortAnswerMarkupContext(question.userResponse, autoFocus));
            default:
               log.logException('Answers-view: unsupported question type (' + question.type + ')');
         }
      };

      var destroy = function() {
         if (!showResults && deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid()) {
            _$window.off('resize', viewHelper.scrollActiveElementIntoView);
         }

         if (_$textInput &&
            (question.type === questionType.FILL_IN || question.type === questionType.SHORT) &&
            (deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid())) {
            _$textInput.off('focus keydown', viewHelper.scrollIntoView);
         }
      };

      var getCorrectAnswerText = function() {
         var answered = !(question.userResponse === null || typeof question.userResponse === 'undefined');
         if (question.type === questionType.CHOICE) {
            answered = answered && question.answers[question.userResponse];
            var correctAnswer = question.answers[getCorrectAnswerIndex()].text;
            var answerText = CORRECT_ANSWER_TEXT + correctAnswer;
            if (answered) {
               answerText += YOUR_ANSWER_TEXT + question.answers[question.userResponse].text;
            }
            return answerText;
         }
         return answered ? YOUR_ANSWER_TEXT + question.userResponse : '';
      };

      var setupAnswers = function() {
         if (showResults) {
            displayResults();
         } else {
            if (deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid()) {
               _$window.on('resize', viewHelper.scrollActiveElementIntoView);
            }

            // remove hover css when device is touch screen
            if (question.type === questionType.CHOICE && deviceInfo.isTouchInterface()) {
               $container.find('.multiple-choice').removeClass(ACTIVE_QUESTION_CLASS);
            }

            _$textInput = $container.find('input[type=text], textarea');
            if (_$textInput && (question.type === questionType.FILL_IN || question.type === questionType.SHORT)) {
               if (deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid()) {
                  _$textInput.on('focus keydown', viewHelper.scrollIntoView);
               }
            }
         }
      };

      var createView = function() {
         var answersMarkup = getAnswersMarkup();
         if (answersMarkup) {
            $container.html(answersMarkup);
         }
         $container.find('.multiple-choice > input').focus(function() {
            $(this).parent().addClass('highlight-background');
         }).blur(function() {
            $(this).parent().removeClass('highlight-background');
         });
      };

      createView();
      setupAnswers();

      return {
         getUserResponse: getUserResponse,
         destroy: destroy,
         getCorrectAnswerText: getCorrectAnswerText
      };
   };

   return {
      /**
       *  Factory method that returns a new QuestionView object.
       *  @function create
       *  @memberof TSC.AnswersView
       *  @static
       *  @return new AnswersView instance
       */
      create: AnswersView
   };
});
